import { render, staticRenderFns } from "./DeleteComic.vue?vue&type=template&id=5e3428c2&scoped=true&"
import script from "./DeleteComic.vue?vue&type=script&lang=js&"
export * from "./DeleteComic.vue?vue&type=script&lang=js&"
import style0 from "./DeleteComic.vue?vue&type=style&index=0&id=5e3428c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3428c2",
  null
  
)

export default component.exports